module.exports = __webpack_public_path__ + "static/media/carAccident.d835bda6.svg";